import React, {Fragment, useEffect, useState} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Popover, Switch, Divider
} from "antd";

import {DownOutlined, DownloadOutlined, DeleteOutlined, PlusOutlined, InfoCircleOutlined} from '@ant-design/icons';

import ApiService from "../../services/ApiService"
import {MiddleSelect} from "antd/es/pagination/Select";
import IntlMessage from "../util-components/IntlMessage";
import TextArea from "antd/es/input/TextArea";
import {useSelector} from "react-redux";
import {getDevise, getDeviseSymbol} from "../permissions/functions";


const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default function MultiAssocForm(props) {
    const [data, setData] = useState([])

    useEffect(() => {
        getData()
    }, [])

    async function getData() {
        var res = await ApiService.get("/auth/assoc")
        console.log(res)

        if (res.success) {
            setData(res.data)
        }
    }

    if (data.length == 0) {
        return null
    }

    let assocs=data
    let label="Association"
    let name="assoc"
    if(props.devise){
        assocs=assocs.filter(assoc => (assoc.devise || getDevise())===props.devise)
        if(props.__deviseSupport){
            label="Association - ("+getDeviseSymbol(props.devise)+")"
            name=[props.devise,"assoc"]
        }
    }

    return (

        <Fragment>

            <Form.Item
                label={label}
                name={name}
                rules={[{required: props.required !== false, message: 'Ce champ est obligatoire'}]}
            >
                <Select disabled={props.disabled} placeholder="Association">
                    {assocs.map((item, index) => <Select.Option key={index}
                                                              value={item.value}>{item.label}</Select.Option>)}
                </Select>
            </Form.Item>

            {/*
                    <Form.Item
                        label="Pointage"
                        name="pointer"
                    >
                        <Switch defaultChecked={props.defaultPointer} />
                    </Form.Item>
            */}


        </Fragment>
    )

}

